(function () {

	angular
		.module('ngmvac')
		.filter('orderPrice', OrderPrice);

	function OrderPrice() {

		return function (arr, orden) {

			var hotelArray = [];

			angular.forEach(arr, function (hotel) {
				hotelArray.push(hotel);

			});

			if (orden == "abajo") {
				hotelArray.sort(function (a, b) {
					if(a.rates == 1){
						return (a.minRatePublica - b.minRatePublica)
					}
					

				})
			} else if (orden == "arriba") {
				hotelArray.sort(function (a, b) {
					if(a.rates == 1){
						return (b.minRatePublica - a.minRatePublica)
					}

				})
			}

			return hotelArray;

		}

	}

})();